<div class="px-4 pt-10 pb-10">
  <p class="font-medium text-black text-4xl w-full">¿Qué trabajaremos hoy?</p>

  <div
    class="mt-6 grid justify-center sm:justify-normal grid-cols-[repeat(auto-fit,185px)]! w-full gap-8"
  >
    @for (item of systems; track $index) {
      @if(item.descripcion !== "" && item.nombre !== "" && item.ruta !== "" && item.icono !== ""){
        <div
          (click)="handleEnterSystem(item)"
          class="border border-[#E4E9EF] flex flex-col gap-4 justify-center items-center shadow-md rounded-xl w-[185px] h-[175px] font-medium text-center p-2 cursor-pointer transition hover:shadow-lg hover:border-[#005FFF] hover:bg-[#e3ecfb52]"
        >
          <div class="h-[100px]">
            @if (item.img && item.img !== "") {
              <img [src]="item.img" class="max-w-[100px] rounded-md" alt="" />
            } @else {
              <img [src]="'assets/img/broken.png'" class="max-w-[100px] rounded-md" alt="Imagen no disponible" />
            }
          </div>
          {{ item.descripcion }}
        </div>
      }
    }
  </div>
</div>
